/**
 * ComingSoonModal — shared "coming soon" dialog.
 * Extracted from Step5PreLien.tsx for reuse across:
 *   - Wizard Step 5 (Preview, Mail for me)
 *   - LienTab (Mail for me)
 *   - SubsTab (Manage subs, View archived)
 *   - PaymentsTab (+ New pay app)
 *   - SubDetail (+ Request doc)
 *
 * Props: isOpen gates rendering; no {flag && <Modal />} wrapper needed at call site.
 */

interface Props {
  isOpen:  boolean
  onClose: () => void
  title:   string
  body:    string
}

export default function ComingSoonModal({ isOpen, onClose, title, body }: Props) {
  if (!isOpen) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="csm-title"
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(9,9,11,.45)',
        backdropFilter: 'blur(2px)',
        zIndex: 600,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--surface)',
          borderRadius: 'var(--rs)',
          padding: 28,
          maxWidth: 440,
          width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,.2)',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div
          id="csm-title"
          style={{ fontSize: 16, fontWeight: 700, color: 'var(--ink)', marginBottom: 10 }}
          data-testid="csm-title"
        >
          {title}
        </div>
        <div style={{ fontSize: 13, color: 'var(--ink3)', lineHeight: 1.6, marginBottom: 20 }}>
          {body}
        </div>
        <button
          className="btn b-dk btn-sm"
          onClick={onClose}
          data-testid="csm-close"
        >
          Got it
        </button>
      </div>
    </div>
  )
}
